module.exports = __webpack_public_path__ + "img/pro_fourteen_4.17c2e37f.jpg";